import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { SystemCodeType, createOptions as createSystemCodeTypeOptions  } from "@project/governingbody/system-code-type";


@Component({
    selector: "system-code-edit",
    template: `
        <p-panel [header]="header">
            <ng-template pTemplate="icons">
                <label class="mr-2">{{overrideLabel}}</label>
                <p-inputSwitch
                        [(ngModel)]="overrideSystemCodeType"
                        [disabled]="!parentCanOrganisationsOverrideSystemCodeType"
                        (onChange)="changedOverrideSwitch.emit($event.checked)"></p-inputSwitch>
            </ng-template>
            <div class="inputs-group-row">
                <label class="inputs-group-row-name">System Code Type:</label> 
                <div class="inputs-group-row-value" rte="fL">
                    <p-dropdown
                        [disabled]="disableDropdown || !parentCanOrganisationsOverrideSystemCodeType"
                        [(ngModel)]="systemCodeType"
                        [options]="systemCodeTypeOptions"
                        [showClear]="false"
                        appendTo="body"
                        placeholder="Select System Code Type"
                        (onChange)="changedSystemCode.emit($event.value)">
                    </p-dropdown>
                </div>  
            </div>
        </p-panel>
`
})
export class SystemCodeSwitchComponent {

    systemCodeTypeOptions = createSystemCodeTypeOptions();

    @Input() header: string = "System Code Type"
    @Input() overrideLabel: string = "Override:"
    @Input() overrideSystemCodeType: boolean;
    @Input() disableDropdown: boolean = false;
    @Input() parentCanOrganisationsOverrideSystemCodeType: boolean = true;
    @Input() systemCodeType: SystemCodeType;

    @Output() readonly changedOverrideSwitch = new EventEmitter<boolean>();
    @Output() readonly changedSystemCode = new EventEmitter<SystemCodeType>();

    constructor() {}
}